import Swiper from 'swiper/dist/js/swiper.min'




/* BASE SLIDER
----------------------------------------------------------------------------------------------------*/

export default function BaseSlider(selector) {
    return new Swiper(selector, {
        // General
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        grabCursor: true,
        roundLengths: true,
        speed: 800,


        // Namespace
        containerModifierClass: 'slider--',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slideVisibleClass: 'slide--visible',
        slideNextClass: 'slide--next',
        slidePrevClass: 'slide--prev',
        slideDuplicateClass: 'slide--dup',
        slideDuplicateActiveClass: 'slide--dup--active',
        slideDuplicateNextClass: 'slide--dup--next',
        slideDuplicatePrevClass: 'slide--dup--prev',


        // Navigation
        pagination: {
            el: '.slider__pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: 'slider__bullet',
            bulletActiveClass: 'slider__bullet--active',
        },

        renderBullet: (index, className) => (
            `<span class="${className}">${index + 1}</span>`
        ),


        // Breakpoints
        breakpoints: {
            960: {
                speed: 400,
            },
        },


        // Callbacks
        on: {
            //
        },
    })
}



